import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import moment from "moment";
import {
  Field,
  reduxForm,
  reset,
  submit,
  stopSubmit,
  setSubmitFailed,
} from "redux-form";
import NoContentAdded, { NO_REVIEWER } from "NoContentAdded";
import Pagination from "react-js-pagination";
import {
  IMAGE_PATH,
  itemCount,
  COMMON_FAIL_MESSAGE,
  ACCESS_FILES_API_KEY,
  BASE_IMAGES_URL,
} from "Constants";
import { showError, showSuccess } from "ReduxErrorBar";
import { Modal, Row, Col, Tabs, Tab } from "react-bootstrap";
import { BaseComponent, LABEL_POSITION_TOP } from "BaseComponent";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import LocaleStrings from "Languages";
import {
  openProposalResponseModal,
  checkProposalReviewCriteria,
  fetchProposalRanking,
  addReviewRank,
  markIncomplete,
  proposalResubmissionMail,
  deleteProposalRank,
  openChangeReviewer,
  openProposalConfirmModal,
  openProposalSendTicketModal,
  makeShortlisted,
  fetchUnreviewedproposal,
  fetchReviewedproposal,
  fetchShortlistedproposal,
  fetchRejectedproposal,
  fetchallproposal,
  updatedDragProposal,
  ratingArrStore,
  showProposalLoader,
  updateproposalComment,
  filterProposalLoader,
  sortByfilter,
} from "ProposalAction";
import { converDateIntoLocalwithmonth } from "Constants";
import { editDashboardUser } from "DashboardUserAction";
import AddUserDialog from "../../../users/components/dashboard-add-user";
import ManageUsersGroup from "ManageUsersGroup";
import StarRatings from "react-star-ratings";

var Loader = require("react-loaders").Loader;

class ProposalResponse extends BaseComponent {
  constructor(props) {
    super(props);
    this.markIncomplete = this.markIncomplete.bind(this);
    this.markReject = this.markReject.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.markApprove = this.markApprove.bind(this);
    this.addUpdateRanking = this.addUpdateRanking.bind(this);
    this.state = {
      loading: false,
      selectedTab: 1,
      dateError: [],
      markloading: false,
      markreject: false,
      markapprove: false,
      rating: 0,
      shortlistloading: false,
      comment: "",
      commentLoading: false,
      mainloading: true,
    };
  }

  componentDidMount() {
    this.props.checkProposalReviewCriteria(this.props.session);
    this.props.fetchProposalRanking(this.props.session, (callback) => {
      this.setState({ mainloading: false });
    });
  }

  handleSelect(key) {
    this.setState({ selectedTab: key });
  }

  closeModal() {
    this.props.openProposalResponseModal(false, "", "");
  }
  renderLoader = () => {
    return (
      <Loader type="line-scale-pulse-out-rapid" active className="loader-div" />
    );
  };

  markIncomplete() {
    this.props.filterProposalLoader(true);
    this.props.sortByfilter(true);
    var { showProposalResponse } = this.props;
    //console.log('response',showProposalResponse.response);
    let currentDate = moment();
    let review_startdate =
      showProposalResponse &&
      showProposalResponse.response &&
      showProposalResponse.response.proposal_by_proposalidfk &&
      showProposalResponse.response.proposal_by_proposalidfk.review_startdate
        ? moment(
            showProposalResponse.response.proposal_by_proposalidfk
              .review_startdate,
            "YYYY-MM-DD"
          )
        : null;
    let review_enddate =
      showProposalResponse &&
      showProposalResponse.response &&
      showProposalResponse.response.proposal_by_proposalidfk &&
      showProposalResponse.response.proposal_by_proposalidfk.review_enddate
        ? moment(
            showProposalResponse.response.proposal_by_proposalidfk
              .review_enddate,
            "YYYY-MM-DD"
          )
        : null;

    if (
      currentDate.isAfter(moment(review_startdate)) &&
      currentDate.isBefore(moment(review_enddate))
    ) {
      let id =
        showProposalResponse &&
        showProposalResponse.response &&
        showProposalResponse.response.id
          ? showProposalResponse.response.id
          : "";

      this.setState({ markloading: true });

      let values = {};
      values.id = id;
      values.markas = "resubmit";
      values.markas_date = moment().format("YYYY-MM-DD HH:mm:ss");
      if (this.state.comment != "" || this.state.comment != "") {
        values.comment = this.state.comment;
      }
      let selectedTab = showProposalResponse.selectedTab;
      // if (selectedTab == "unreviewed") {
      //   values.status = "reviewed";
      //   selectedTab = "unreviewed";
      // }
      values.status = "unreviewed";
      values.avg_rating = 0;
      //console.log('resubmit',values);
      this.props.markIncomplete(this.props.session, values, (response) => {
        if (response.success === 0) {
          this.setState({ markloading: false });
          this.props.showError(COMMON_FAIL_MESSAGE);
        } else {
          this.props.proposalResubmissionMail(
            this.props.session,
            values,
            (feedback) => {
              if (feedback.success === 0) {
                this.setState({ markloading: false });
                this.props.showError(COMMON_FAIL_MESSAGE);
              } else {
                // if (showProposalResponse.selectedTab == "reviewed") {
                  this.props.deleteProposalRank(
                    this.props.session,
                    id,
                    (response) => {
                      document.getElementById("sortbyHandle").value = "none";
                      // this.props.handleSelect(showProposalResponse.selectedTab);
                      this.props.fetchallproposal(
                        this.props.session,
                        (callback) => {
                          this.props.updatedDragProposal(true);
                          this.setState({ markreject: false });
                          this.props.showSuccess(
                            LocaleStrings.proposal_response_resubission
                          );
                          this.closeModal();
                        }
                      );
                    }
                  );
                // } else {
                //   // this.props.handleSelect(showProposalResponse.selectedTab);
                //   this.props.fetchallproposal(
                //     this.props.session,
                //     (callback) => {
                //       this.props.updatedDragProposal(true);
                //       this.props.ratingArrStore({});
                //       this.setState({ markloading: false });
                //       this.props.showSuccess(
                //         LocaleStrings.proposal_response_resubission
                //       );
                //       this.closeModal();
                //     }
                //   );
                // }
              }
              // this.closeModal();
            }
          );
        }
      });
    } else {
      this.props.showError(LocaleStrings.proposal_response_review_date_expired);
      this.closeModal();
    }
  }

  markApprove() {
    var { showProposalResponse } = this.props;
    //console.log("showProposalResponse", showProposalResponse);

    let id =
      showProposalResponse &&
      showProposalResponse.response &&
      showProposalResponse.response.id
        ? showProposalResponse.response.id
        : "";
    let values = {};
    values.id = id;
    values.markas = "";
    values.markas_date = moment().format("YYYY-MM-DD HH:mm:ss");
    //console.log("values", values);
    this.setState({ markapprove: true });
    this.props.markIncomplete(this.props.session, values, (response) => {
      //console.log("response", response);
      if (response.success == 0) {
        this.setState({ markapprove: false });
        this.props.showError(COMMON_FAIL_MESSAGE);
      } else {
        document.getElementById("sortbyHandle").value = "none";
        // this.props.handleSelect(showProposalResponse.selectedTab);
        this.props.fetchallproposal(this.props.session, (callback) => {
          this.props.updatedDragProposal(true);
          this.setState({ markapprove: false });
          this.props.showSuccess(LocaleStrings.proposal_response_approved);
          this.closeModal();
        });
      }
    });
  }

  markReject() {
    this.props.filterProposalLoader(true);
    this.props.sortByfilter(true);
    var { showProposalResponse } = this.props;

    let markas =
      showProposalResponse &&
      showProposalResponse.response &&
      showProposalResponse.response.markas
        ? showProposalResponse.response.markas
        : "";
    let id =
      showProposalResponse &&
      showProposalResponse.response &&
      showProposalResponse.response.id
        ? showProposalResponse.response.id
        : "";
    let values = {};
    values.id = id;
    if (this.state.comment != "" || this.state.comment != "") {
      values.comment = this.state.comment;
    }
    // values.markas =  markas == "" ? "reject" : markas == "resubmit" ? "reject" : "";
    values.markas = "reject";
    values.markas_date = moment().format("YYYY-MM-DD HH:mm:ss");
    let selectedTab = showProposalResponse.selectedTab;
    if (
      selectedTab == "unreviewed" ||
      selectedTab == "shortlisted" ||
      selectedTab == "reviewed"
    ) {
      values.status = "reviewed";
      values.avg_rating = 0;
      // selectedTab = "reviewed";
    }
    this.setState({ markreject: true });
    this.props.markIncomplete(this.props.session, values, (response) => {
      if (response.success === 0) {
        this.setState({ markreject: false });
        this.props.showError(COMMON_FAIL_MESSAGE);
      } else {
        if (showProposalResponse.selectedTab == "reviewed") {
          this.props.deleteProposalRank(this.props.session, id, (response) => {
            document.getElementById("sortbyHandle").value = "none";
            // this.props.handleSelect(showProposalResponse.selectedTab);
            this.props.fetchallproposal(this.props.session, (callback) => {
              this.props.updatedDragProposal(true);
              this.setState({ markreject: false });
              this.props.showSuccess(
                values.markas == "reject"
                  ? LocaleStrings.proposal_response_reject
                  : LocaleStrings.proposal_response_approved
              );
              this.closeModal();
            });
          });
        } else {
          document.getElementById("sortbyHandle").value = "none";
          // this.props.handleSelect(showProposalResponse.selectedTab);
          this.props.fetchallproposal(this.props.session, (callback) => {
            this.props.updatedDragProposal(true);
            this.closeModal();
            this.setState({ markreject: false });
            this.props.showSuccess(
              values.markas == "reject"
                ? LocaleStrings.proposal_response_reject
                : LocaleStrings.proposal_response_approved
            );
            this.closeModal();
          });
        }
      }
    });
  }

  onSubmitForm = (values) => {
    //console.log('values',values);
    //console.log('showProposalResponse',this.props.showProposalResponse);
    var { showProposalResponse, proposalReviewCriteriaStatus } = this.props;

    let currentDate = moment();
    let review_startdate =
      showProposalResponse &&
      showProposalResponse.response &&
      showProposalResponse.response.proposal_by_proposalidfk &&
      showProposalResponse.response.proposal_by_proposalidfk.review_startdate
        ? moment(
            showProposalResponse.response.proposal_by_proposalidfk
              .review_startdate,
            "YYYY-MM-DD"
          )
        : null;
    let review_enddate =
      showProposalResponse &&
      showProposalResponse.response &&
      showProposalResponse.response.proposal_by_proposalidfk &&
      showProposalResponse.response.proposal_by_proposalidfk.review_enddate
        ? moment(
            showProposalResponse.response.proposal_by_proposalidfk
              .review_enddate,
            "YYYY-MM-DD"
          )
        : null;

    if (
      currentDate.isAfter(moment(review_startdate)) &&
      currentDate.isBefore(moment(review_enddate))
    ) {
      let criteriaListArr =
        proposalReviewCriteriaStatus &&
        proposalReviewCriteriaStatus.data &&
        proposalReviewCriteriaStatus.data.length > 0
          ? proposalReviewCriteriaStatus.data
          : [];
      let criteriaList = _.filter(criteriaListArr, function (o) {
        return o.proposalidfk === showProposalResponse.response.proposalidfk;
      });
      let c = 0;

      var dateError = [];
      if (criteriaList.length > 0) {
        _.map(criteriaList, (opt, index) => {
          var errorMessage = {};
          if (!values["rank" + opt.criteriaid]) {
            errorMessage.rank =
              LocaleStrings.tickets_ticket_form_validation_required;
            c++;
          } else {
            errorMessage.rank = "";
          }
          dateError.push(errorMessage);
        });

        if (c > 0) {
          this.setState({ dateError: dateError });

          setTimeout(() => {
            this.setState({ dateError: [] });
          }, 2000);
        } else {
          let criteriaArr = [];
          _.map(criteriaList, (opt, index) => {
            let obj = {
              responseidfk: showProposalResponse.response.id,
              criteriaidfk: opt.criteriaid,
              criterianame: opt.categoryname,
              rating: values["rank" + opt.criteriaid],
              eventid: this.props.session.eventid,
            };
            criteriaArr.push(obj);
          });
          if (criteriaArr.length > 0) {
            let responseid = showProposalResponse.response.id;
            this.setState({ loading: true });
            this.props.addReviewRank(
              this.props.session,
              criteriaArr,
              responseid,
              "",
              (response) => {
                if (response.success === 0) {
                  this.setState({ loading: false });
                  this.props.showError(COMMON_FAIL_MESSAGE);
                } else {
                  let values = {};
                  values.id = responseid;
                  values.markas = "";
                  values.markas_date = moment().format("YYYY-MM-DD HH:mm:ss");
                  this.props.markIncomplete(
                    this.props.session,
                    values,
                    (response) => {
                      document.getElementById("sortbyHandle").value = "none";
                      // this.props.handleSelect(showProposalResponse.selectedTab);
                      this.props.fetchallproposal(
                        this.props.session,
                        (callback) => {
                          this.props.updatedDragProposal(true);
                          this.setState({ loading: false });
                          this.props.showSuccess(
                            LocaleStrings.proposal_review_rank_add_succesfully
                          );
                          this.closeModal();
                        }
                      );
                    }
                  );
                }
              }
            );
          }
        }
      }
    } else {
      this.props.showError(LocaleStrings.proposal_response_review_date_expired);
    }
  };
  changeReviewer = () => {
    this.props.filterProposalLoader(true);
    this.props.sortByfilter(true);
    let { showProposalResponse } = this.props;
    this.props.openChangeReviewer(true, showProposalResponse.response);
  };

  confirmProposal = () => {
    this.props.filterProposalLoader(true);
    this.props.sortByfilter(true);
    let { showProposalResponse } = this.props;

    this.props.openProposalConfirmModal(true, showProposalResponse.response);
  };
  sendTicket = () => {
    this.props.filterProposalLoader(true);
    this.props.sortByfilter(true);
    let { showProposalResponse, handleSelect } = this.props;
    this.props.openProposalSendTicketModal(true, showProposalResponse.response);
  };

  makeShortList = () => {
    this.props.filterProposalLoader(true);
    this.props.sortByfilter(true);
    let { showProposalResponse } = this.props;
    this.setState({ shortlistloading: true });
    let values = {};
    if (this.state.comment != "" || this.state.comment != "") {
      values.comment = this.state.comment;
    }
    values.status = "shortlisted";
    values.id = showProposalResponse.response.id;
    this.props.makeShortlisted(this.props.session, values, (response) => {
      //console.log('proposal',response);
      if (response.success === 0) {
        this.setState({ shortlistloading: false });
        this.props.showError(COMMON_FAIL_MESSAGE);
      } else {
        document.getElementById("sortbyHandle").value = "none";
        // this.props.handleSelect("shortlisted");
        this.props.fetchallproposal(this.props.session, (callback) => {
          this.props.updatedDragProposal(true);
          this.setState({ shortlistloading: false });
          this.props.showSuccess(LocaleStrings.proposal_shorlisted_succesfully);
          this.closeModal();
        });
      }
    });
  };
  _handleComment = (e) => {
    // console.log('e',e.target.value)
    this.setState({ comment: e.target.value });
  };
  _saveComment = () => {
    this.props.filterProposalLoader(true);
    this.props.sortByfilter(true);
    this.setState({ commentLoading: true });
    let values = {};
    values.id = this.props.showProposalResponse.response.id;
    if (this.state.comment != "") {
      values.comment = this.state.comment;
    } else {
      this.setState({ commentLoading: false });
      this.props.showError("Please add a comment");
      return false;
    }
    this.props.updateproposalComment(this.props.session, values, (response) => {
      //console.log('proposal',response);
      if (response.success === 0) {
        this.setState({ commentLoading: false });
        this.props.showError(COMMON_FAIL_MESSAGE);
      } else {
        document.getElementById("sortbyHandle").value = "none";
        this.props.fetchallproposal(this.props.session, (callback) => {
          this.props.updatedDragProposal(true);
          this.props.showSuccess("Comment updated");
          this.setState({ commentLoading: false });
        });
      }
    });
  };

  editUser(e, userObject) {
    // console.log('userObject',userObject)
    userObject.commingFrom = "proposal_shortlisted"
    this.props.editDashboardUser(userObject);
  }

  addUpdateRanking() {
    this.props.filterProposalLoader(true);
    this.props.sortByfilter(true);
    let ratingZero = [];
    var { showProposalResponse, proposalReviewCriteriaStatus, ratingStore } =
      this.props;
    let comesfrom = "";
    // console.log('showProposalResponse.selectedTab',showProposalResponse.selectedTab)
    if (showProposalResponse.selectedTab == "shortlisted") {
      comesfrom = "shortlisted";
    }

    if (_.isEmpty(ratingStore)) {
      this.props.showError("Some category's rank is not selected.");
      return false;
    }
    if (!_.isEmpty(ratingStore) && ratingStore.rating.length > 0) {
      ratingZero = _.filter(ratingStore.rating, function (o) {
        return o.rating === 0;
      });
    }

    if (ratingZero.length > 0) {
      this.props.showError("Some category's rank is not selected.");
      return false;
    } else {
      let section = 0;
      if (ratingStore.rating.length > 0) {
        let sumRating = _.sumBy(ratingStore.rating, function (o) {
          // console.log('o',o)
          return o.rating;
        });
        section = (sumRating / ratingStore.rating.length).toFixed(2);
      }

      let currentDate = moment();
      let review_startdate =
        showProposalResponse &&
        showProposalResponse.response &&
        showProposalResponse.response.proposal_by_proposalidfk &&
        showProposalResponse.response.proposal_by_proposalidfk.review_startdate
          ? moment(
              showProposalResponse.response.proposal_by_proposalidfk
                .review_startdate,
              "YYYY-MM-DD"
            )
          : null;
      let review_enddate =
        showProposalResponse &&
        showProposalResponse.response &&
        showProposalResponse.response.proposal_by_proposalidfk &&
        showProposalResponse.response.proposal_by_proposalidfk.review_enddate
          ? moment(
              showProposalResponse.response.proposal_by_proposalidfk
                .review_enddate,
              "YYYY-MM-DD"
            )
          : null;

      if (
        currentDate.isAfter(moment(review_startdate)) &&
        currentDate.isBefore(moment(review_enddate))
      ) {
        let criteriaList = ratingStore.rating;

        let criteriaArr = [];
        _.map(criteriaList, (opt, index) => {
          let obj = {
            responseidfk: showProposalResponse.response.id,
            criteriaidfk: opt.id,
            criterianame: opt.criterianame,
            rating: opt.rating,
            eventid: parseInt(this.props.session.eventid),
          };
          criteriaArr.push(obj);
        });
        if (criteriaArr.length > 0) {
          let responseid = showProposalResponse.response.id;
          this.setState({ loading: true });
          this.props.addReviewRank(
            this.props.session,
            criteriaArr,
            responseid,
            comesfrom,
            (response) => {
              if (response.success != 1) {
                this.setState({ loading: false });
                this.props.showError(COMMON_FAIL_MESSAGE);
              } else {
                let values = {};
                values.id = responseid;
                values.markas = null;
                values.markas_date = moment().format("YYYY-MM-DD HH:mm:ss");
                values.avg_rating = section;
                if (this.state.comment != "" || this.state.comment != "") {
                  values.comment = this.state.comment;
                }
                this.props.markIncomplete(
                  this.props.session,
                  values,
                  (response) => {
                    document.getElementById("sortbyHandle").value = "none";
                    // this.props.handleSelect(showProposalResponse.selectedTab);
                    this.props.fetchallproposal(
                      this.props.session,
                      (callback) => {
                        this.props.updatedDragProposal(true);
                        this.props.ratingArrStore({});
                        this.setState({ loading: false });
                        this.props.showSuccess(
                          LocaleStrings.proposal_review_rank_add_succesfully
                        );
                        this.closeModal();
                      }
                    );
                  }
                );
              }
            }
          );
        }
      } else {
        this.props.showError(
          LocaleStrings.proposal_response_review_date_expired
        );
      }
    }
  }

  render() {
    var {
      handleSubmit,
      pristine,
      reset,
      submitting,
      invalid,
      showProposalResponse,
      proposalReviewCriteriaStatus,
      proposalRanking,
      proposalAttendeeList,
    } = this.props;
    var savedForm =
      showProposalResponse && showProposalResponse.response
        ? JSON.parse(showProposalResponse.response.response_JSON)
        : [];
    // let criteriaListArr = proposalReviewCriteriaStatus && proposalReviewCriteriaStatus.data && proposalReviewCriteriaStatus.data.length > 0 ? proposalReviewCriteriaStatus.data : [];
    let rankingList = _.filter(proposalRanking.data, function (o) {
      return o.responseidfk === showProposalResponse.response.id;
    });
    // console.log("showProposalResponse.response.proposal_by_proposalidfk", showProposalResponse.response.proposal_by_proposalidfk);
    // console.log("savedForm", savedForm);

    let buttonVisible = true;
    if (
      showProposalResponse.response &&
      showProposalResponse.response.markas == "reject"
    ) {
      buttonVisible = false;
    } else if (
      showProposalResponse.response &&
      showProposalResponse.response.markas == "resubmit"
    ) {
      buttonVisible = false;
    }

    let fileList =
      savedForm.length > 0
        ? _.filter(savedForm, function (obj) {
            return obj.key === "file";
          })
        : [];

    let attendeeList = [];
    if (
      proposalAttendeeList &&
      proposalAttendeeList.resource &&
      proposalAttendeeList.resource.length > 0
    ) {
      attendeeList = _.filter(proposalAttendeeList.resource, function (o) {
        // console.log('o',o);
        // console.log('showProposalResponse.response.email',showProposalResponse.response.email)
        return o.email === showProposalResponse.response.email;
      });
    }
    // console.log('proposalAttendeeList.resource',proposalAttendeeList.resource)
    // console.log('proposalAttendeeList',showProposalResponse.response)
    let section = "Not rated yet";
    if (
      // (showProposalResponse.response.status == "reviewed" || showProposalResponse.selectedTab == "shortlisted") &&
      showProposalResponse.response.proposal_review_by_responseidfk &&
      showProposalResponse.response.proposal_review_by_responseidfk.length > 0
    ) {
      let sumRating = _.sumBy(
        showProposalResponse.response.proposal_review_by_responseidfk,
        function (o) {
          return o.rating;
        }
      );
      section = (
        sumRating /
        showProposalResponse.response.proposal_review_by_responseidfk.length
      ).toFixed(2);
    }

    let username = "Admin";
    // let added_on = '';
    if (
      showProposalResponse.response.reviewer_by_reviewerid &&
      !_.isEmpty(showProposalResponse.response.reviewer_by_reviewerid)
    ) {
      username = showProposalResponse.response.reviewer_by_reviewerid.username;
    }
    // console.log('savedForm',savedForm)
    return (
      <div>
        <Modal
          className="modal-container"
          dialogClassName="modal-lg"
          enforceFocus={false}
          show={showProposalResponse.showModal === true ? true : false}
          animation={true}
        >
          <Modal.Header>
            <div className="import-modal-title">
              {LocaleStrings.view_proposal}
            </div>
            <button
              type="button"
              className="i-custom-cross-popup pull-right"
              onClick={() => this.closeModal()}
            >
              <img
                className="i-custom-small"
                src="../../style/images/custom-icons/cross-black.png"
              />
            </button>
          </Modal.Header>
          <form onSubmit={handleSubmit(this.onSubmitForm)}>
            <Modal.Body>
              <div
                className="proposal-view-modal"
                style={{ height: "1000px", overflowY: "auto" }}
              >
                <div>Submission Status</div>
                <div style={{ display: "flex" }}>
                  <div className="submission-status-box">
                    <span
                      className="proposal-header-box"
                      style={{ backgroundColor: showProposalResponse.bgColor }}
                    ></span>
                    <span
                      className="proposal-status"
                      style={{ paddingLeft: "10px" }}
                    >
                      {_.startCase(showProposalResponse.selectedTab)}
                    </span>
                  </div>
                  {showProposalResponse.response.status == "unreviewed" &&
                  showProposalResponse.response.markas == "resubmit" ? (
                    <div className="resubmit-proposal-reponse">
                      <span>Re-Submit</span>
                    </div>
                  ) : (
                    ""
                  )}
                  <div style={{ marginLeft: "auto" }}>
                    {showProposalResponse.selectedTab == "shortlisted" &&
                    attendeeList.length > 0 ? (
                      <Button
                        className="proposal-green-button"
                        bsStyle=""
                        onClick={(e) => this.editUser(e, attendeeList[0])}
                      >
                        View Profile
                      </Button>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className="col-md-12 view-abstract-box">
                  <div className="view-abstract-small-box">
                    <div className="abstract-modalbox-title">Abstract Name</div>
                    <div className="abstract-modalbox-subtitle">
                      {
                        showProposalResponse.response.proposal_by_proposalidfk
                          .proposal_name
                      }
                    </div>
                  </div>
                  <div className="view-abstract-small-box">
                    <div className="abstract-modalbox-title">Submitted By</div>
                    <div className="abstract-modalbox-subtitle">
                      {showProposalResponse.response.firstname}{" "}
                      {showProposalResponse.response.lastname}
                    </div>
                  </div>
                  <div className="view-abstract-small-box">
                    <div className="abstract-modalbox-title">
                      Submission Date
                    </div>
                    <div className="abstract-modalbox-subtitle">
                      {converDateIntoLocalwithmonth(
                        showProposalResponse.response.submission_date
                      ).format("D MMM YYYY HH:mm A")}
                    </div>
                  </div>
                  <div className="view-abstract-small-box">
                    <div className="abstract-modalbox-title">
                      Submission Category
                    </div>
                    <div className="abstract-modalbox-subtitle">
                      {_.startCase(
                        showProposalResponse.response.proposal_by_proposalidfk
                          .category
                      )}
                    </div>
                  </div>
                  <div className="view-abstract-small-box">
                    <div className="abstract-modalbox-title">Assigned To</div>
                    <div
                      className="abstract-modalbox-subtitle"
                      style={{ display: "flex" }}
                    >
                      <span>{_.startCase(username)} </span>
                      {showProposalResponse.response.status == "unreviewed" ? (
                        <span
                          className="change-reviewerbox"
                          onClick={this.changeReviewer}
                        >
                          {" "}
                          Change{" "}
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <div className="view-abstract-small-box">
                    <div className="abstract-modalbox-title">Average Point</div>
                    <div
                      className="abstract-modalbox-subtitle"
                      style={{ display: "flex" }}
                    >
                      <img src="../../style/images/yellowstar.png" />
                      <span style={{ paddingLeft: "5px" }}>{section}</span>
                    </div>
                  </div>
                </div>

                <div
                  className="col-md-12 view-abstract-box"
                  style={{ marginTop: "20px", marginBottom: "15px" }}
                >
                  {_.map(savedForm, (form, index) => {
                    var label = form.label;
                    // console.log("form", form);
                    return form.key != "singlecheckbox" &&
                      form.key != "label" &&
                      form.key != "group" ? (
                      <div
                        className="view-abstract-small-box"
                        // style={{ paddingBottom: "5px" }}
                        key={index}
                      >
                        <div className="abstract-modalbox-title">
                          <span>{label}</span>
                        </div>
                        <div className="abstract-modalbox-subtitle">
                          {form.key == "checkboxes" ? (
                            form.value.join(", ")
                          ) : form.key == "hyperlink" ? (
                            <a href={form.value} target="_blank">
                              {form.value}
                            </a>
                          ) : 
                         
                          form.key == "file" ? (
                            <span>{form.value && form.value.length > 0 ?(
                            
                              <span>
                                { _.map(form.value, (fl, co) => {
                              var filenameArr = fl.split("/");
                              //console.log('filenameArr',filenameArr);
                              var filename =
                                filenameArr[filenameArr.length - 1];
                              var fileurl =
                                BASE_IMAGES_URL +
                                "/" +
                                fl +
                                "?api_key=" +
                                ACCESS_FILES_API_KEY;
                              return (
                                <div className="view-abstract-small-box-">
                                  <div
                                    className="abstract-modalbox-subtitle"
                                    style={{ paddingBottom: "7px" }}
                                    key={co}
                                  >
                                    <a href={fileurl} target="_blank">
                                      {filename}
                                    </a>
                                  </div>
                                </div>
                              );
                              })}

                              </span>
                            
                            ):('')}</span>
                        )
                        :form.value && form.value != "" && form.value.indexOf("http") >= 0 ||
                        form.value.indexOf("https") >= 0 ? (
                        <a href={form.value} target="_blank">
                          {form.value}
                        </a>
                      ) 
                      :  (
                            form.value
                          )}
                        </div>
                      </div>
                    ) : (
                      ""
                    );
                  })}
                </div>
                {/* <span className="header-textfile">File Attachment</span> */}
                {/* {fileList.length > 0 &&
                fileList[0].value &&
                fileList[0].value.length > 0 ? (
                  <span>
                    <span className="header-textfile">File Attachment</span>
                    <div
                      className="col-md-12 view-abstract-box"
                      style={{
                        marginTop: "10px",
                        marginBottom: "15px",
                        backgroundColor: "aliceblue",
                      }}
                    >
                      {_.map(fileList, (form, index) => {
                        var name = form.name;
                        var files = form.value;
                        return form.key == "file"
                          ? _.map(files, (fl, co) => {
                              var filenameArr = fl.split("/");
                              //console.log('filenameArr',filenameArr);
                              var filename =
                                filenameArr[filenameArr.length - 1];
                              var fileurl =
                                BASE_IMAGES_URL +
                                "/" +
                                fl +
                                "?api_key=" +
                                ACCESS_FILES_API_KEY;
                              return (
                                <div className="view-abstract-small-box">
                                  {co == 0 ? (
                                    <div
                                      className="abstract-modalbox-title"
                                      style={{ paddingBottom: "7px" }}
                                    >
                                      {form.label}
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                  <div
                                    className="abstract-modalbox-subtitle"
                                    style={{ paddingBottom: "7px" }}
                                    key={co}
                                  >
                                    <a href={fileurl} target="_blank">
                                      {filename}
                                    </a>
                                  </div>
                                </div>
                              );
                            })
                          : "";
                      })}
                    </div>
                  </span>
                ) : (
                  ""
                )} */}
                {this.state.mainloading ? (
          <div className="loader-container">
            {this.renderLoader()}
            <div className="loader-info">{this.state.desc}</div>
          </div>
        ) : (
          <span>
                {!_.isEmpty(proposalReviewCriteriaStatus) ? (
                  <span>
                    {showProposalResponse.selectedTab == "unreviewed" ? (
                      <div>
                        <RankForm
                          {...this.props}
                          dateError={this.state.dateError}
                        />
                      </div>
                    ) : showProposalResponse.selectedTab == "reviewed" ? (
                      // <RankForm
                      //   {...this.props}
                      //   dateError={this.state.dateError}
                      // />
                      <div className="basicform">
                        <div className="form-group row">
                          <div className="col-sm-12 col-sm-offset-0 view-abstract-box">
                            {rankingList && rankingList.length > 0
                              ? _.map(rankingList, (ranking, index) => {
                                
                                  return (
                                    <div className="col-md-12 view-abstract-small-box">
                                      <div className="abstract-modalbox-title">
                                        {ranking.criterianame}
                                      </div>
                                      <div className="abstract-modalbox-subtitle">
                                        {/* <div className=""> */}
                                        {/* {ranking.rating} */}
                                        <StarRatings
                                          //rating={this.state.rating}
                                          rating={ranking.rating ? ranking.rating : 0}
                                          starRatedColor="#F6AB2E"
                                          starEmptyColor="#D5DBE7"
                                          starHoverColor="#F6AB2E"
                                          numberOfStars={
                                            ranking
                                              .review_criteria_by_criteriaidfk
                                              .range == "1-5"
                                              ? 5
                                              : 10
                                          }
                                          name="ranks"
                                          // name="rating"
                                          starDimension="20px"
                                          starSpacing="1px"
                                          // changeRating={(newRating, name) =>
                                          //   this.rating(newRating, name)
                                          // }
                                        />
                                      </div>
                                    </div>
                                  );
                                })
                              : ""}
                          </div>
                        </div>
                      </div>
                    ) : showProposalResponse.selectedTab == "rejected" &&
                      showProposalResponse.response &&
                      showProposalResponse.response.markas &&
                      showProposalResponse.response.markas != "" ? (
                      <RankForm
                        {...this.props}
                        dateError={this.state.dateError}
                      />
                    ) : showProposalResponse.selectedTab == "shortlisted" &&
                      showProposalResponse.response ? (
                      <span>
                        {showProposalResponse.response.avg_rating == 0 ||
                        showProposalResponse.response.avg_rating == null ||
                        showProposalResponse.response.avg_rating == "" ? (
                          <RankForm
                            {...this.props}
                            dateError={this.state.dateError}
                          />
                        ) : (
                          <div className="basicform">
                            <div className="form-group row">
                              <div className="col-sm-12 col-sm-offset-0 view-abstract-box">
                                {rankingList && rankingList.length > 0
                                  ? _.map(rankingList, (ranking, index) => {
                                      return (
                                        <div className="col-md-12 view-abstract-small-box">
                                          <div className="abstract-modalbox-title">
                                            {ranking.criterianame}
                                          </div>
                                          <div className="abstract-modalbox-subtitle">
                                            {/* <div className=""> */}
                                            {/* {ranking.rating} */}
                                            <StarRatings
                                              //rating={this.state.rating}
                                              rating={ranking.rating}
                                              starRatedColor="#F6AB2E"
                                              starEmptyColor="#D5DBE7"
                                              starHoverColor="#F6AB2E"
                                              numberOfStars={
                                                ranking
                                                  .review_criteria_by_criteriaidfk
                                                  .range == "1-5"
                                                  ? 5
                                                  : 10
                                              }
                                              name="ranks"
                                              // name="rating"
                                              starDimension="20px"
                                              starSpacing="1px"
                                              // changeRating={(newRating, name) =>
                                              //   this.rating(newRating, name)
                                              // }
                                            />
                                          </div>
                                        </div>
                                      );
                                    })
                                  : ""}
                              </div>
                            </div>
                          </div>
                        )}
                      </span>
                    ) : (
                      ""
                    )}
                  </span>
                ) : (
                  ""
                )}
</span>
 )}
                {showProposalResponse.selectedTab != "unreviewed" ? (
                  <div
                    className=""
                    style={{
                      textAlign: "end",
                      fontWeight: 500,
                      marginTop: "10px",
                    }}
                  >
                    {" "}
                    Reviewed By <span>{_.startCase(username)}</span>{" "}
                  </div>
                ) : (
                  ""
                )}
                <div>
                  <Field
                    name="comment"
                    label="Comment"
                    placeholder="Comment"
                    component={this.renderFieldTextarea}
                    labelposition={LABEL_POSITION_TOP}
                    onChange={(e) => this._handleComment(e)}
                  />
                </div>
                <span>
                  <Button
                    className="btn btn-primary"
                    bsStyle=""
                    loading={this.state.commentLoading}
                    type="button"
                    onClick={this._saveComment}
                  >
                    {this.props.initialValues.comment == null ||
                    this.props.initialValues.comment == ""
                      ? "Save Comment"
                      : "Update Comment"}
                  </Button>
                </span>
              </div>

              {/* <Tabs
                className="branding-tabs mt-0"
                id="speaker-from-tab"
                activeKey={this.state.selectedTab}
                onSelect={this.handleSelect}
              >
                <Tab
                  className="pt-15"
                  eventKey={1}
                  title={LocaleStrings.view_proposal_tab1}
                >
                  <div className="row">
                   
                    {_.map(savedForm, (form, index) => {
                      var label = form.label;
                      console.log("form", form);
                      return form.key != "file" &&
                        form.key != "singlecheckbox" &&
                        form.key != "label" &&
                        form.key != "group" ? (
                        <div
                          className="col-md-12"
                          style={{ paddingBottom: "5px" }}
                          key={index}
                        >
                          <div className="col-md-7">
                            <b>{label}</b>
                          </div>
                          <div className="col-md-5">
                            {form.key == "checkboxes" ? (
                              form.value.join(", ")
                            ) : form.key == "hyperlink" ? (
                              <a href={form.value} target="_blank">
                                {form.value}
                              </a>
                            ) : form.value.indexOf("http") >= 0 ||
                              form.value.indexOf("https") >= 0 ? (
                              <a href={form.value} target="_blank">
                                {form.value}
                              </a>
                            ) : (
                              form.value
                            )}
                          </div>
                        </div>
                      ) : (
                        ""
                      );
                    })}
                  </div>
                </Tab>
                {fileList.length > 0 &&
                fileList[0].value &&
                fileList[0].value.length > 0 ? (
                  <Tab
                    className="pt-15"
                    eventKey={2}
                    title={LocaleStrings.view_proposal_tab2}
                  >
                    <div className="row">
                      {_.map(fileList, (form, index) => {
                        var name = form.name;
                        var files = form.value;
                        return form.key == "file"
                          ? _.map(files, (fl, co) => {
                              var filenameArr = fl.split("/");
                              //console.log('filenameArr',filenameArr);
                              var filename =
                                filenameArr[filenameArr.length - 1];
                              var fileurl =
                                BASE_IMAGES_URL +
                                "/" +
                                fl +
                                "?api_key=" +
                                ACCESS_FILES_API_KEY;
                              return (
                                <div>
                                  {co == 0 ? (
                                    <div
                                      className="col-md-12"
                                      style={{ paddingBottom: "7px" }}
                                    >
                                      {form.label}
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                  <div
                                    className="col-md-12"
                                    style={{ paddingBottom: "7px" }}
                                    key={co}
                                  >
                                    <div className="col-md-10">
                                      <a href={fileurl} target="_blank">
                                        {filename}
                                      </a>
                                    </div>
                                    <div className="col-md-2"></div>
                                  </div>
                                </div>
                              );
                            })
                          : "";
                      })}
                    </div>
                  </Tab>
                ) : (
                  ""
                )}
                <Tab
                  className="pt-15"
                  eventKey={3}
                  title={LocaleStrings.view_proposal_tab3}
                >
                  {showProposalResponse.selectedTab == "unreviewed" ? (
                    <div>
                      <RankForm
                        {...this.props}
                        dateError={this.state.dateError}
                      />
                    </div>
                  ) : showProposalResponse.selectedTab == "reviewed" &&
                    showProposalResponse.response &&
                    showProposalResponse.response.markas &&
                    showProposalResponse.response.markas != "" ? (
                    <div>
                      <RankForm
                        {...this.props}
                        dateError={this.state.dateError}
                      />
                    </div>
                  ) : (
                    <div className="basicform">
                      <div className="form-group row">
                        <div className="col-sm-12 col-sm-offset-0">
                          {rankingList && rankingList.length > 0
                            ? _.map(rankingList, (ranking, index) => {
                                return (
                                  <div className="col-md-12">
                                    <div className="col-md-5">
                                      {ranking.criterianame}
                                    </div>
                                    <div className="col-md-5">
                                      {ranking.rating}
                                    </div>
                                  </div>
                                );
                              })
                            : ""}
                        </div>
                      </div>
                    </div>
                  )}
                </Tab>
              </Tabs> */}
            </Modal.Body>
            <Modal.Footer>
              {/* {showProposalResponse.selectedTab != "shortlisted" &&
              showProposalResponse.response &&
              showProposalResponse.response.markas != "resubmit" ? (
                <Button
                  className="btn btn-custom-blue ml-10"
                  bsStyle=""
                  loading={this.state.markreject}
                  type="button"
                  onClick={this.markReject}
                >
                  {showProposalResponse.response &&
                  showProposalResponse.response.markas == "reject"
                    ? LocaleStrings.proposal_mark_as_approve
                    : LocaleStrings.proposal_mark_as_reject}
                </Button>
              ) : (
                ""
              )} */}

              {showProposalResponse.selectedTab == "shortlisted" ? (
                <>
                  {attendeeList.length > 0 ? (
                    ""
                  ) : (
                   
                      <>
                        <div style={{ marginRight: "auto" }}>
                          {showProposalResponse.selectedTab == "shortlisted" &&
                          attendeeList.length < 1 ? (
                            <Button
                              className="btn proposal-red-button"
                              bsStyle=""
                              loading={this.state.markreject}
                              type="button"
                              onClick={this.markReject}
                            >
                              {LocaleStrings.proposal_mark_as_reject}
                            </Button>
                          ) : (
                            ""
                          )}

                          <Button
                            className="btn proposal-black-button ml-10"
                            bsStyle=""
                            loading={this.state.markloading}
                            type="button"
                            onClick={this.markIncomplete}
                          >
                            {LocaleStrings.proposal_mark_as_incomplete_btn}
                          </Button>
                        </div>
                        <div style={{ marginLeft: "auto" }}>
                          <Button
                            className="btn-custom-white ml-30"
                            bsStyle=""
                            onClick={this.closeModal}
                          >
                            {LocaleStrings.button_close}
                          </Button>
                          {showProposalResponse.response.ticketurlsend == 0 ? (
                            <Button
                              className="proposal-blue-button ml-10"
                              bsStyle=""
                              onClick={this.sendTicket}
                            >
                              Send Ticket
                            </Button>
                          ) : (
                            <Button
                              className="proposal-blue-button ml-10"
                              bsStyle=""
                              onClick={this.sendTicket}
                            >
                              Re-Send Ticket
                            </Button>
                          )}
                          {attendeeList.length > 0 ? (
                            ""
                          ) : (
                            <Button
                              className="proposal-green-button ml-10"
                              bsStyle=""
                              onClick={this.confirmProposal}
                            >
                              Confirm
                            </Button>
                          )}
                          {showProposalResponse.response.avg_rating == 0 ||
                          showProposalResponse.response.avg_rating == null ||
                          showProposalResponse.response.avg_rating == "" ? (
                            <Button
                              className="proposal-green-button ml-10 ml-10"
                              bsStyle=""
                              loading={this.state.loading}
                              onClick={this.addUpdateRanking}
                            >
                              Rate Submission
                            </Button>
                          ) : (
                            ""
                          )}
                        </div>
                      </>
                    
                  )}
                </>
              ) : showProposalResponse.selectedTab == "unreviewed" &&
                showProposalResponse.response &&
                showProposalResponse.response.markas == null ? (
                <>
                  <div>
                    <Button
                      className="btn proposal-red-button"
                      bsStyle=""
                      loading={this.state.markreject}
                      type="button"
                      onClick={this.markReject}
                    >
                      {LocaleStrings.proposal_mark_as_reject}
                    </Button>

                    <Button
                      className="btn proposal-black-button ml-10"
                      bsStyle=""
                      loading={this.state.markloading}
                      type="button"
                      onClick={this.markIncomplete}
                    >
                      {LocaleStrings.proposal_mark_as_incomplete_btn}
                    </Button>
                  </div>
                  <div style={{ marginLeft: "auto" }}>
                    <Button
                      className="btn btn-custom-white"
                      bsStyle=""
                      onClick={this.closeModal}
                    >
                      {LocaleStrings.button_close}
                    </Button>

                    {/* <Button
                    className="btn proposal-green-button ml-10"
                    bsStyle=""
                    loading={this.state.loading}
                    disabled={pristine || invalid || submitting}
                    type="submit"
                  >
                   Rate Submission
                  </Button> */}
                    <Button
                      className="proposal-green-button ml-10"
                      bsStyle=""
                      loading={this.state.loading}
                      onClick={this.addUpdateRanking}
                    >
                      Rate Submission
                    </Button>
                  </div>

                  {/* <OverlayTrigger
                    placement="left"
                    overlay={
                      <Tooltip style={{ marginTop: "2px" }}>
                        {LocaleStrings.proposal_rate_info_text}
                      </Tooltip>
                    }
                  >
                    <img
                      src="../../style/images/header-icons/infoicon.png"
                      style={{
                        paddingTop: 3,
                        cursor: "pointer",
                        paddingLeft: 8,
                      }}
                    />
                  </OverlayTrigger> */}
                </>
              ) : showProposalResponse.selectedTab == "unreviewed" &&
                showProposalResponse.response &&
                showProposalResponse.response.markas == "resubmit" ? (
                <>
                  <div>
                    <Button
                      className="btn proposal-red-button"
                      bsStyle=""
                      loading={this.state.markreject}
                      type="button"
                      onClick={this.markReject}
                    >
                      {LocaleStrings.proposal_mark_as_reject}
                    </Button>
                    <Button
                      className="btn proposal-black-button ml-10"
                      bsStyle=""
                      loading={this.state.markloading}
                      type="button"
                      onClick={this.markIncomplete}
                    >
                      {LocaleStrings.proposal_mark_as_incomplete_btn}
                    </Button>
                  </div>
                  <div style={{ marginLeft: "auto" }}>
                    <Button
                      className="btn btn-custom-white"
                      bsStyle=""
                      onClick={this.closeModal}
                    >
                      {LocaleStrings.button_close}
                    </Button>

                    <Button
                      className="proposal-green-button ml-10"
                      bsStyle=""
                      loading={this.state.loading}
                      onClick={this.addUpdateRanking}
                    >
                      Rate Submission
                    </Button>
                  </div>
                </>
              ) : showProposalResponse.selectedTab == "rejected" &&
                showProposalResponse.response &&
                showProposalResponse.response.markas == "reject" ? (
                <>
                  <div>
                    <Button
                      className="proposal-black-button"
                      bsStyle=""
                      loading={this.state.markloading}
                      type="button"
                      onClick={this.markIncomplete}
                    >
                      {LocaleStrings.proposal_mark_as_incomplete_btn}
                    </Button>
                    <Button
                      className="proposal-green-button"
                      bsStyle=""
                      onClick={this.makeShortList}
                      loading={this.state.shortlistloading}
                      style={{marginLeft:'8px'}}
                    >
                      Move to Shortlist
                    </Button>
                  </div>
                  <div style={{ marginLeft: "auto" }}>
                    <Button
                      className="btn-custom-white"
                      bsStyle=""
                      onClick={this.closeModal}
                    >
                      {LocaleStrings.button_close}
                    </Button>
                    <Button
                      className="proposal-green-button ml-10"
                      bsStyle=""
                      loading={this.state.loading}
                      onClick={this.addUpdateRanking}
                    >
                      Rate Submission
                    </Button>
                  </div>

                  {/* <OverlayTrigger
                    placement="left"
                    overlay={
                      <Tooltip style={{ marginTop: "2px" }}>
                        {LocaleStrings.proposal_rate_info_text}
                      </Tooltip>
                    }
                  >
                    <img
                      src="../../style/images/header-icons/infoicon.png"
                      style={{
                        paddingTop: 3,
                        cursor: "pointer",
                        paddingLeft: 8,
                      }}
                    />
                  </OverlayTrigger> */}
                </>
              ) : showProposalResponse.selectedTab == "reviewed" &&
                showProposalResponse.response &&
                (showProposalResponse.response.markas == null ||
                  showProposalResponse.response.markas == "") ? (
                <>
                  <div>
                    <Button
                      className="proposal-red-button"
                      bsStyle=""
                      loading={this.state.markreject}
                      type="button"
                      onClick={this.markReject}
                    >
                      {LocaleStrings.proposal_mark_as_reject}
                    </Button>

                    <Button
                      className="proposal-black-button ml-10"
                      bsStyle=""
                      loading={this.state.markloading}
                      type="button"
                      onClick={this.markIncomplete}
                    >
                      {LocaleStrings.proposal_mark_as_incomplete_btn}
                    </Button>
                  </div>
                  <div style={{ marginLeft: "auto" }}>
                    <Button
                      className="btn btn-custom-white"
                      bsStyle=""
                      onClick={this.closeModal}
                      style={{marginRight:'10px'}}
                    >
                      {LocaleStrings.button_close}
                    </Button>
                    <Button
                      className="proposal-green-button"
                      bsStyle=""
                      onClick={this.makeShortList}
                      loading={this.state.shortlistloading}
                    >
                      Move to Shortlist
                    </Button>
                  </div>
                  {/* <Button
                    className="btn btn-custom-white"
                    bsStyle=""
                    onClick={this.closeModal}
                  >
                    {LocaleStrings.button_close}
                  </Button> */}
                </>
              ) : (
                ""
              )}

              {/* {showProposalResponse.selectedTab == "unreviewed" &&
              buttonVisible ? (
                <div>
                  <Button
                    className="btn btn-custom-white"
                    bsStyle=""
                    onClick={this.closeModal}
                  >
                    {LocaleStrings.button_close}
                  </Button>
                  <Button
                    className="btn btn-custom-blue ml-10"
                    bsStyle=""
                    loading={this.state.loading}
                    disabled={pristine || invalid || submitting}
                    type="submit"
                  >
                    {LocaleStrings.rank_proposal}
                  </Button>
                </div>
              ) : (
                ""
              )} */}
            </Modal.Footer>
          </form>
        </Modal>
        <div hidden>
          <AddUserDialog finishOperationsCallback={this.userAdditionCallback} />
        </div>
        {this.props.ShowUserCategoryModal ? (
          <ManageUsersGroup
            finishOperationsCallback={this.userAdditionCallback}
          />
        ) : null}
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    session: state.session,
    showProposalResponse: state.showProposalResponse,
    proposalReviewCriteriaStatus: state.proposalReviewCriteriaStatus,
    proposalRanking: state.proposalRanking,
    proposalAttendeeList: state.proposalAttendeeList,
    ShowUserCategoryModal: state.ShowDashboardUserCategoryModal,
    ratingStore: state.ratingStore,
    initialValues: state.showProposalResponse.response,
  };
}

function validate(values) {
  // console.log('values',values);
  var errors = {};

  return errors;
}

export default connect(mapStateToProps, {
  fetchProposalRanking,
  showError,
  showSuccess,
  openProposalResponseModal,
  checkProposalReviewCriteria,
  addReviewRank,
  markIncomplete,
  proposalResubmissionMail,
  deleteProposalRank,
  openChangeReviewer,
  openProposalConfirmModal,
  openProposalSendTicketModal,
  makeShortlisted,
  editDashboardUser,
  fetchUnreviewedproposal,
  fetchReviewedproposal,
  fetchShortlistedproposal,
  fetchRejectedproposal,
  ratingArrStore,
  showProposalLoader,
  fetchallproposal,
  updatedDragProposal,
  updateproposalComment,
  filterProposalLoader,
  sortByfilter,
})(
  reduxForm({
    validate,
    form: "ProposalForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(ProposalResponse)
);

class RankForm extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      // rating: 0,
      rating: [],
    };
  }

  componentDidMount() {
    var { showProposalResponse, proposalReviewCriteriaStatus } = this.props;
    let ratingNameArr = [];

    let criteriaListArr =
      proposalReviewCriteriaStatus &&
      proposalReviewCriteriaStatus.data &&
      proposalReviewCriteriaStatus.data.length > 0
        ? proposalReviewCriteriaStatus.data
        : [];
    let criteriaList = _.filter(criteriaListArr, function (o) {
      return o.proposalidfk === showProposalResponse.response.proposalidfk;
    });

    {
      _.map(criteriaList, (opt, index) => {
        // console.log('criteriaList123',criteriaList)
        ratingNameArr.push({
          id: opt.criteriaid,
          rating: 0,
          criterianame: opt.categoryname,
        });
      });
    }
    this.setState({ rating: ratingNameArr });
  }
  rating = (newRating, name) => {
    let { rating } = this.state;

    _.map(rating, (value, index) => {
      if (value.id === name) {
        value.rating = parseInt(newRating);
      }
    });
    this.setState({ rating });
    this.props.ratingArrStore(rating);
  };

  /* Retun rating if matched with id */
  getRatingWIthId = (id) => {
    let { rating } = this.state;
    if (_.size(rating) > 0) {
      let singleRating = _.filter(rating, ["id", id]); // array of objects
      return singleRating[0].rating;
    } else {
      return 0;
    }
  };

  render() {
    var { showProposalResponse, proposalReviewCriteriaStatus } = this.props;
    let criteriaListArr =
      proposalReviewCriteriaStatus &&
      proposalReviewCriteriaStatus.data &&
      proposalReviewCriteriaStatus.data.length > 0
        ? proposalReviewCriteriaStatus.data
        : [];
    let criteriaList = _.filter(criteriaListArr, function (o) {
      return o.proposalidfk === showProposalResponse.response.proposalidfk;
    });
    //console.log('criteriaList',criteriaList);
    return (
      <div className="basicform">
        <span className="header-textfile">Rank Submission</span>
        <div
          className="col-md-12 view-abstract-box"
          style={{ marginTop: "10px" }}
        >
          {_.map(criteriaList, (opt, index) => {
            var rangeArr = opt.range.split("-");
            var rangeStart = rangeArr[0];
            var rangeEnd = rangeArr[1];
            var rankOption = [];
            for (let i = rangeStart; i <= rangeEnd; i++) {
              rankOption.push({ val: i });
            }
            // console.log('opt',opt)
            return (
              <div className=" view-abstract-small-box" key={index}>
                <div className="">{opt.categoryname}</div>
                <div className="" style={{ marginLeft: "auto" }}>
                  <div className="form-group row">
                    <div
                      className="col-sm-12 col-sm-offset-0"
                      style={{ display: "flex" }}
                    >
                      <div style={{ marginLeft: "auto" }}>
                        <StarRatings
                          //rating={this.state.rating}
                          rating={this.getRatingWIthId(opt.criteriaid)}
                          starRatedColor="#F6AB2E"
                          starEmptyColor="#D5DBE7"
                          starHoverColor="#F6AB2E"
                          numberOfStars={rankOption.length}
                          name={opt.criteriaid}
                          // name="rating"
                          starDimension="20px"
                          starSpacing="1px"
                          changeRating={(newRating, name) =>
                            this.rating(newRating, name)
                          }
                        />
                      </div>
                      {/* {_.map(rankOption, (item, ctr) => {
                          return (
                            <div key={ctr}>
                              <Field
                                name={"rank" + opt.criteriaid}
                                label={item.val}
                                value={item.val.toString()}
                                type="radio"
                                component={this.renderFieldRadio}
                              />
                              <StarRatings
                                rating={0}
                                starRatedColor="#009CDE"
                                starEmptyColor="#D5DBE7"
                                starHoverColor="#009CDE"
                                // numberOfStars={1}
                                name="rating"
                                starDimension="20px"
                                starSpacing="1px"
                                changeRating={(newRating, name) =>
                                  this.rating(newRating, name)
                                } 
                              />
                              
                            </div>
                          );
                        })} */}
                    </div>
                    {this.props.dateError &&
                    this.props.dateError[index] &&
                    this.props.dateError[index].rank &&
                    this.props.dateError[index].rank !== "" ? (
                      <div className="col-sm-12 col-sm-offset-0">
                        <span style={{ color: "#d43f3a" }}>
                          {this.props.dateError[index].rank}
                        </span>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}
